export const cellStyle = {
  padding: '0px',
};

export const headerStyle = {
  padding: '0px',
  backgroundColor: '#f5f5f5',
};

export const conditionHeaderStyle = {
  padding: '6px',
  backgroundColor: '#f5f5f5',
};

export const conditionCellStyle = {
  padding: '6px',
};

export const selectedCellStyle = { cursor: 'pointer', backgroundColor: '#daeffc' };
export const unselectedStyle = { cursor: 'pointer' };

